module.exports = __webpack_public_path__ + "img/chili_oil_deconstructed.561bff40.jpg";